import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { compose } from 'recompose';

import { withEscHandler } from 'shared/hocs/modalWithEscHandler';
import { currentModal } from 'modules/messageSystem/selectors';

import AvatarUploadFileSizeExceeded from './AvatarUploadFileSizeExceeded';

function mapStateToProps(state) {
  const modal = currentModal(state);

  return {
    onCancel: modal.onCancel,
    fileType: modal.bodyValues.fileType,
    maxSizeMB: modal.bodyValues.maxSizeMB,
  };
}

export default compose(
  connect(mapStateToProps),
  withEscHandler,
  injectIntl,
)(AvatarUploadFileSizeExceeded);
